module.exports = __webpack_public_path__ + "static/IMG_3546-1014d7eb34e3c991f0c7b2de8d249f55.jpg";